import script from "./M365Integration.vue?vue&type=script&setup=true&lang=js"
export * from "./M365Integration.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__